







































































































































































































































































































import { PatientInfo } from "@/types";
import { Component, Watch } from "vue-property-decorator";
import Vue from "vue";
import { appModule } from "@/store/modules/app";
import { placeModule } from "@/store/modules/place";
import {
  getDefaultPagination,
  getDefaultPatientOptions,
} from "@/utils/store-util";
import { patientModule } from "../store/modules/patients";
import { DOWNLOADKEYS } from "../utils/store-util";
import { has_value } from "../utils/app-util";
// import { patientRecordsModule } from "../store/modules/patientRecords";
@Component
export default class PatientList extends Vue {
  public timeselected = 0;
  public json_fields = DOWNLOADKEYS;
  public switchMask = true;
  public ticksLabels = ['一周','一個月','半年','一年'];
  public headers = [
    {
      text: "名稱",
      left: true,
      sortable: false,
      value: "name",
    },
    { text: "身份證字號", sortable: false, value: "iid" },
    { text: "性別", sortable: false, value: "gender" },
    { text: "年齡", sortable: false, value: "age" },
    { text: "生日", sortable: false, value: "birthday" },
    { text: "電話", sortable: false, value: "phone" },
    { text: "信箱", sortable: false, value: "email" },
    { text: "其他操作", value: "actions", sortable: false },
  ];
  public editDialog = false;
  public editItem = {
    age: 0,
    birthday: "",
    created_at: "",
    gender: "",
    health_state: 0,
    iid: 0,
    id_card: "",
    name: "",
    phone: "",
    updated_at: "",
    uuid: "",
    email: "",
    place: "",
  };
  private dateMenu = false;
  private date = new Date().toISOString().substr(0, 10);
  private patientOptions = getDefaultPatientOptions();

  private lastSearch = "";
  private lastSearchplace = "";

  get downloadjson(){
    return patientModule.downloadjson;
  }
  get loading() {
    return patientModule.loading;
  }

  get d_loading() {
    return patientModule.download_loading;
  }

  get place() {
    return placeModule.place;
  }

  get pagination() {
    return patientModule.pagination;
  }

  set pagination(pagination) {
    patientModule.setPagination(pagination);
  }

  get patients() {
    return patientModule.patients;
  }

  get totalPatients() {
    return patientModule.totalPatients;
  }

  get items() {
    return patientModule.items;
  }
  get downloaduuid(){
    return patientModule.downloaduuid;
  }

  async created() {
    this.pagination = getDefaultPagination();
    await placeModule.placeList();
    if(has_value(this.$router.currentRoute.params.place)) {
      const tempFc = this.$router.currentRoute.params.place.replace('-',',');
      this.patientOptions.place = await placeModule.codetoPlace({place:tempFc});
      this.lastSearchplace = this.patientOptions.place;
    }else if(has_value(this.$router.currentRoute.params.chineseplace)){
      this.patientOptions.place = this.$router.currentRoute.params.chineseplace
      this.lastSearchplace = this.patientOptions.place;
    }
    if(has_value(this.$router.currentRoute.params.q)) {
      this.patientOptions.q = this.$router.currentRoute.params.q;
      this.lastSearch = this.patientOptions.q;
    }
    if(has_value(this.$router.currentRoute.params.page)) {
      this.patientOptions.page = Number(this.$router.currentRoute.params.page);
    }
    await this.updateTableData();
  }
  handlecsvSuccess(val){
    console.log(val);
  }
  handlecsvError(val){
    console.log(val);
  }
  async handledownload(){
    let query_range = "7,d";
    switch(this.timeselected){
      case 0:
        query_range="7,d";
        break;
      case 1:
        query_range="1,m";
        break;
      case 2:
        query_range="6,m";
        break;
      case 3:
        query_range="12,m";
        break;
      default:
        query_range = "7,d";
    }
    // console.log(query_range);
    this.patientOptions['range'] = query_range;
    await patientModule.getDownloadData(this.patientOptions);
    // console.log(query_range);
    // console.log(this.downloadjson);
    if(typeof this.downloadjson === 'undefined' || this.downloadjson.length === 0){
      appModule.sendErrorNotice("無資料可下載");
    }
    return this.downloadjson;
    
  }

  async updateTableData() {
    if (!this.loading) {
      if (this.patientOptions.q !== this.lastSearch || this.patientOptions.place !== this.lastSearchplace) {
        this.patientOptions.page = 1;
        this.lastSearch = this.patientOptions.q;
        this.lastSearchplace = this.patientOptions.place;
      }
    }
    patientModule.getPatientsByPages(this.patientOptions);
  }

  createPatient() {
    this.$router.push("newPatient");
  }

  async changeToPatientRecordPage(item) {
    this.$router.push({
      name: `個案紀錄`,
      params: {
        id: item.uuid,
        chineseplace: this.patientOptions.place,
        q: this.patientOptions.q,
        page: this.patientOptions.page.toString(),
      },
    });
  }

  async edit(item: PatientInfo[]) {
    this.editDialog = true;
    this.editItem = JSON.parse(JSON.stringify(item));
    if (this.editItem.phone !== null && this.editItem.phone.length>10){
      this.editItem.phone = this.editItem.phone.substring(4,this.editItem.phone.length);
    }
    this.editItem.place = await placeModule.codetoPlace(item);
  }

  closeEdit() {
    this.editItem = {
      age: 0,
      birthday: "",
      created_at: "",
      gender: "",
      health_state: 0,
      iid: 0,
      id_card: "",
      name: "",
      phone: "",
      updated_at: "",
      uuid: "",
      email: "",
      place: "",
    };
    this.editDialog = false;
  }

  async saveEdit() {
    if (this.editItem.gender === "男") this.editItem.gender = "1";
    else if (this.editItem.gender === "女") this.editItem.gender = "2";
    if (this.editItem.phone != "") {
      this.editItem.phone = "+886" + this.editItem.phone;
    }

    await placeModule.placetoCode(this.editItem);

    
    const params = {
      age: this.editItem.age,
      gender: this.editItem.gender,
      phone: this.editItem.phone,
      place: this.editItem.place,
      birthday: this.editItem.birthday
    };
    // 改名字的功能
    if(this.editItem.name.indexOf("◯") == -1) params['name'] = this.editItem.name;

    const data = {
      uuid: this.editItem.uuid,
      params: params,
    };

    await patientModule.setPatientsInfo(data);
    this.closeEdit();
    await patientModule.getPatientsByPages(this.patientOptions);
  }

  @Watch("patientOptions.q",{immediate:false, deep:false})
  watchSearch(newVal, oldVal) {
    if (newVal != this.lastSearch && newVal == "") {
      this.updateTableData();
    }
  }
  @Watch("patientOptions.place",{immediate:false, deep:false})
  watchPlace(newVal, oldVal) {
    if (newVal !== this.lastSearchplace) {
      this.updateTableData();
    }
  }
}
